import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  serviceAreas = [
    'Georgetown',
    'Round Rock',
    'Pflugerville',
    'Hutto',
    'Cedar Park',
    'Liberty Hill',
    'Jarrell',
    'Austin',
    'Buda',
    'Kyle'
  ];

  trustBadges = [
    'Home checkup clarity',
    'Licensed and bonded',
    'TREC# 23635',
    'Central Texas'
  ];

  footerHighlights = [
    {
      label: 'License',
      value: 'Professional Inspector · TREC# 23635',
      note: 'Texas inspection license information is kept visible across the site.'
    },
    {
      label: 'Privacy',
      value: 'Service-focused contact forms',
      note: 'Form details are used to respond to requests and coordinate inspection service.'
    },
    {
      label: 'Resources',
      value: 'Informational provider contacts',
      note: 'Clients should independently verify licensing, insurance, pricing, reviews, and fit.'
    }
  ];

  complianceNotes = [
    'Professional Inspector TREC# 23635',
    'Privacy-first contact forms',
    'Consumer Protection Notice linked',
    'Provider resources are informational'
  ];
}
